import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import "react-dates/lib/css/_datepicker.css";
import { SingleDatePicker } from "react-dates";
import Checkbox from "../../../../../UI/Form/Checkbox";
import useUniqueId from "../../../../../Hooks/useUniqueId";
import PersonService from "../../../../../../Services/Person.service";
import FAIcon from "../../../../../UI/FAIcon/FAIcon";
import ActivityItemTypeService from "../../../../../../Domain/ActivityItemType/ActivityItemType.service";
import SurveyFilters, { getItemEventSearchPieceFromSurveyFilterState, } from "./SurveyFilters";
import TaskFilters, { getItemEventSearchPieceFromTaskFilterState, } from "./TaskFilters";
import MeetingFilters, { getItemEventSearchPieceFromMeetingFilterState, } from "./MeetingFilters";
import { debouncePromise } from "../../../../../../../util/debounce";
import Modal from "../../../../../UI/Modal/Modal";
import { ModalHeaderCloseButton } from "../../../../../UI/Modal/ModalHeader";
import { OkButton } from "../../../../../UI/StandardButtons/StandardButtons";
import Dot from "../../../../../UI/Dot/Dot";
import useService from "../../../../../Hooks/useService";
import { StaffActivityFilterStorageService, StudentFilterUpdateFeedFiltersStorageService, } from "../../../../../../Services/Shared/LocalStorage.service";
import { AlertInfo } from "../../../../../UI/StandardAlerts/StandardAlerts";
import ActivityService from "../../../../../../Services/Activity.service";
import DeprecatedSelect from "../../../../../UI/DeprecatedSelect/DeprecatedSelect";
import { usePersonTypeInternalName } from "../../../../../Hooks/usePersonType";
const initialState = {
    // @ts-expect-error - TS2322 - Type '{ alertFilters: {}; noteFilters: {}; achievementFilters: {}; surveyFilters: {}; taskFilters: {}; meetingFilters: {}; globalFilters: { eventCreators: never[]; startDate: null; endDate: null; }; }' is not assignable to type 'StaffActivityFilterState'.
    alertFilters: {},
    noteFilters: {},
    achievementFilters: {},
    surveyFilters: {},
    taskFilters: {},
    meetingFilters: {},
    globalFilters: { eventCreators: [], startDate: null, endDate: null },
};
const getValue = (setState, statePartial) => {
    if (typeof setState === "function") {
        return setState(statePartial);
    }
    return setState;
};
const checkboxesDefaultValue = {
    [ActivityItemTypeService.MeetingId.toString()]: true,
    [ActivityItemTypeService.SurveyId.toString()]: true,
    [ActivityItemTypeService.TaskId.toString()]: true,
    [ActivityItemTypeService.PersonId.toString()]: true,
};
const FilterBox = ({ personId, onFilter }) => {
    const makeId = useUniqueId()[1];
    const personTypeName = usePersonTypeInternalName();
    const [startDateFocused, setStartDateFocused] = React.useState(false);
    const [endDateFocused, setEndDateFocused] = React.useState(false);
    const [filtersState, setFiltersState] = React.useState(initialState);
    const [modalIsOpen, setModalIsOpen] = React.useState(false);
    const [me, loadMe] = useService(PersonService.me);
    React.useEffect(() => {
        loadMe();
    }, [loadMe]);
    const [filterEnableState, getEnabledFilters] = useService(ActivityService.getEnabledFiltersForContextPerson);
    React.useEffect(() => {
        // @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string'.
        getEnabledFilters(personId, personTypeName);
    }, [personId, getEnabledFilters, personTypeName]);
    const options = React.useMemo(() => [
        {
            text: "Meetings",
            id: ActivityItemTypeService.MeetingId,
            state: filtersState.meetingFilters,
            node: (_jsx(MeetingFilters, { personId: personId, search: filtersState.meetingFilters, setSearch: (meetingFilters) => setFiltersState((state) => (Object.assign(Object.assign({}, state), { meetingFilters: getValue(meetingFilters, state.meetingFilters) }))) })),
        },
        {
            text: "Surveys",
            id: ActivityItemTypeService.SurveyId,
            state: filtersState.surveyFilters,
            node: (_jsx(SurveyFilters, { personId: personId, search: filtersState.surveyFilters, setSearch: (surveyFilters) => setFiltersState((state) => (Object.assign(Object.assign({}, state), { surveyFilters: getValue(surveyFilters, state.surveyFilters) }))) })),
        },
        {
            text: "Tasks",
            id: ActivityItemTypeService.TaskId,
            state: filtersState.taskFilters,
            node: (_jsx(TaskFilters, { search: filtersState.taskFilters, setSearch: (taskFilters) => setFiltersState((state) => (Object.assign(Object.assign({}, state), { taskFilters: getValue(taskFilters, state.taskFilters) }))) })),
        },
        {
            text: "Resource Shared",
            state: {},
            id: ActivityItemTypeService.ResourceShareId,
            node: null,
        },
        {
            text: "Comments",
            state: {},
            id: ActivityItemTypeService.PersonId,
            node: null,
        },
    ].filter((option) => filterEnableState.data && filterEnableState.data[option.id]), [
        filterEnableState.data,
        filtersState.meetingFilters,
        filtersState.surveyFilters,
        filtersState.taskFilters,
        personId,
    ]);
    const getItemEventSearch = React.useCallback((filters, checkState) => {
        const global = Object.values(checkState).filter((val) => val).length <
            Object.values(checkboxesDefaultValue).length
            ? {
                activityItemTypeIds: Object.keys(checkState)
                    .filter((key) => checkState[key])
                    .map((key) => parseInt(key, 10)),
            }
            : {};
        const typeIdItemEventSearchMapping = {
            [ActivityItemTypeService.SurveyId]: getItemEventSearchPieceFromSurveyFilterState(filters.surveyFilters),
            [ActivityItemTypeService.TaskId]: getItemEventSearchPieceFromTaskFilterState(filters.taskFilters),
            [ActivityItemTypeService.MeetingId]: getItemEventSearchPieceFromMeetingFilterState(filters.meetingFilters),
            [ActivityItemTypeService.ResourceShareId]: null,
            [ActivityItemTypeService.PersonId]: null,
        };
        const latestValue = [];
        if (Object.values(typeIdItemEventSearchMapping).some((val) => val != null)) {
            Object.keys(typeIdItemEventSearchMapping).forEach((key) => {
                if (checkState[key]) {
                    // @ts-expect-error - TS7015 - Element implicitly has an 'any' type because index expression is not of type 'number'.
                    const search = typeIdItemEventSearchMapping[key];
                    if (search) {
                        latestValue.push(search);
                    }
                    else {
                        latestValue.push({
                            // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'number'.
                            activityItemTypeIds: [key],
                        });
                    }
                }
            });
        }
        return {
            global,
            latestValue,
            eventCreatedByPeoplePersonIds: filters.globalFilters.eventCreators.map((person) => person.personId),
            eventDateFrom: filters.globalFilters.startDate &&
                filters.globalFilters.startDate.toDate(),
            eventDateTo: filters.globalFilters.endDate &&
                filters.globalFilters.endDate.toDate(),
        };
    }, []);
    const [checkBoxStates, setCheckBoxStates] = React.useState(checkboxesDefaultValue);
    const [loadedFilterFromLocalStorage, setLoadedFilterFromLocalStorage] = React.useState(false);
    React.useEffect(() => {
        var _a;
        if (me.data && filterEnableState.wasSuccessful) {
            // Fetch the checkbox state from local storage, or set it to the default value if it's not in local storage
            const checkboxState = ((_a = StudentFilterUpdateFeedFiltersStorageService.get(me.data.personId)) === null || _a === void 0 ? void 0 : _a.checkboxes) || checkboxesDefaultValue;
            const permissionedCheckboxState = Object.keys(checkboxState).reduce((state, key) => (Object.assign(Object.assign({}, state), { [key]: filterEnableState.data
                    ? // If we have permission data, set the checkbox to true if they set it to true and have permission to.
                        filterEnableState.data[parseInt(key, 10)] && checkboxState[key]
                    : // otherwise just set it to what it's set to.
                        checkboxState[key] })), {});
            setCheckBoxStates(permissionedCheckboxState);
            setLoadedFilterFromLocalStorage(true);
        }
    }, [
        personId,
        me.data,
        filterEnableState.wasSuccessful,
        filterEnableState.data,
    ]);
    const numCheckBoxesChecked = Object.values(checkBoxStates).filter((checked) => checked).length;
    React.useEffect(() => {
        if (me.data && filterEnableState.wasSuccessful) {
            StaffActivityFilterStorageService.set(me.data.personId, {
                checkboxes: checkBoxStates,
            });
        }
    }, [checkBoxStates, filterEnableState.wasSuccessful, me, personId]);
    React.useEffect(() => {
        if (loadedFilterFromLocalStorage) {
            onFilter(getItemEventSearch(filtersState, checkBoxStates));
        }
    }, [
        checkBoxStates,
        filtersState,
        getItemEventSearch,
        loadedFilterFromLocalStorage,
        onFilter,
    ]);
    const allSelected = React.useMemo(() => options.every((option) => checkBoxStates[option.id.toString()]), [checkBoxStates, options]);
    let itemsLabel = "All Items";
    if (!allSelected) {
        if (numCheckBoxesChecked === 1) {
            itemsLabel = "1 Item";
        }
        else {
            itemsLabel = `${numCheckBoxesChecked} Items`;
        }
    }
    const itemsHasRedDot = React.useMemo(() => options.some((option) => checkBoxStates[option.id.toString()] &&
        Object.values(option.state).some((val) => val != null && val.length !== 0)), [checkBoxStates, options]);
    return (_jsxs("div", { className: "d-flex flex-wrap", children: [_jsxs("button", { className: "btn btn-link mr-1", type: "button", onClick: () => setModalIsOpen(true), children: [itemsLabel, itemsHasRedDot && _jsx(Dot, {}), _jsx(FAIcon, { icon: "chevron-down", className: "ml-1" })] }), _jsx("div", { className: "mr-3", children: _jsxs("div", { className: "dropdown", children: [_jsxs("button", { className: "btn btn-link", type: "button", id: makeId("people-dropdown"), "data-toggle": "dropdown", "aria-haspopup": "true", "aria-expanded": "false", children: [filtersState.globalFilters.eventCreators &&
                                    filtersState.globalFilters.eventCreators.length > 0
                                    ? filtersState.globalFilters.eventCreators.length
                                    : "", " ", filtersState.globalFilters.eventCreators &&
                                    filtersState.globalFilters.eventCreators.length === 1
                                    ? "Person"
                                    : "People", _jsx(FAIcon, { icon: "chevron-down", className: "ml-1" })] }), _jsx("div", { className: "dropdown-menu dropdown-menu-right shadow", style: { width: 400 }, children: _jsx("form", { children: _jsx("div", { className: "p-3", children: _jsx(DeprecatedSelect.Async, { multi: true, loadOptions: debouncePromise((search) => PersonService.simpleSearch(search).then((results) => ({
                                            options: results,
                                        }))), placeholder: "People", valueKey: "personId", labelKey: "fullName", value: filtersState.globalFilters.eventCreators, onChange: (eventCreators) => setFiltersState((state) => (Object.assign(Object.assign({}, state), { globalFilters: Object.assign(Object.assign({}, state.globalFilters), { eventCreators }) }))) }) }) }) })] }) }), _jsx("div", { className: "d-flex align-items-center", children: _jsxs("div", { className: "d-flex react-date-single-picker-group", children: [_jsx(SingleDatePicker, { numberOfMonths: 1, displayFormat: "M/D/YYYY", 
                            // @ts-expect-error - TS2322 - Type 'Moment | null | undefined' is not assignable to type 'Moment | null'.
                            date: filtersState.globalFilters.startDate, id: makeId("updatedFromDate"), placeholder: "date from", onDateChange: (date) => {
                                if (!date && !filtersState.globalFilters.startDate) {
                                    return date;
                                }
                                setFiltersState((state) => (Object.assign(Object.assign({}, state), { globalFilters: Object.assign(Object.assign({}, state.globalFilters), { startDate: date }) })));
                                const { endDate } = filtersState.globalFilters;
                                if (endDate && !endDate.isAfter(date)) {
                                    setFiltersState((state) => (Object.assign(Object.assign({}, state), { globalFilters: Object.assign(Object.assign({}, state.globalFilters), { endDate: date }) })));
                                }
                                return date;
                            }, focused: startDateFocused, isOutsideRange: () => false, onFocusChange: ({ focused }) => setStartDateFocused(focused), small: true }), _jsx(SingleDatePicker, { numberOfMonths: 1, displayFormat: "M/D/YYYY", 
                            // @ts-expect-error - TS2322 - Type 'Moment | null | undefined' is not assignable to type 'Moment | null'.
                            date: filtersState.globalFilters.endDate, id: makeId("updatedToDate"), placeholder: "date to", onDateChange: (date) => {
                                if (!date && !filtersState.globalFilters.endDate) {
                                    return date;
                                }
                                setFiltersState((state) => (Object.assign(Object.assign({}, state), { globalFilters: Object.assign(Object.assign({}, state.globalFilters), { endDate: date }) })));
                                const { startDate } = filtersState.globalFilters;
                                if (startDate && startDate.isAfter(date)) {
                                    setFiltersState((state) => (Object.assign(Object.assign({}, state), { globalFilters: Object.assign(Object.assign({}, state.globalFilters), { startDate: date }) })));
                                }
                                return date;
                            }, focused: endDateFocused, isOutsideRange: () => false, onFocusChange: ({ focused }) => setEndDateFocused(focused), small: true })] }) }), _jsxs(Modal, { isOpen: modalIsOpen, onModalClosed: () => setModalIsOpen(false), size: "xl", children: [_jsxs("div", { className: "modal-header pl-4", children: [_jsx(Checkbox, { id: makeId("select-all"), label: "Select All", checked: allSelected, onChange: () => {
                                    setCheckBoxStates(options.reduce((sum, option) => (Object.assign(Object.assign({}, sum), { [option.id]: !allSelected })), {}));
                                } }), _jsx(ModalHeaderCloseButton, { closeModal: () => setModalIsOpen(false) })] }), _jsxs("div", { className: "modal-body p-4", children: [_jsx("div", { className: "row", children: options.map((option, index) => {
                                    var _a;
                                    return (_jsxs("div", { className: "col-12 col-md-6 col-lg-4", children: [_jsx(Checkbox, { className: "d-inline", checked: checkBoxStates[(_a = option.id) === null || _a === void 0 ? void 0 : _a.toString()], onChange: (e) => {
                                                    const { checked } = e.target;
                                                    setCheckBoxStates((states) => (Object.assign(Object.assign({}, states), { [option.id]: checked })));
                                                }, id: makeId(option.text), label: _jsxs("span", { children: [_jsx(FAIcon, { icon: ActivityItemTypeService.getIcon(option.id), className: `text-${ActivityItemTypeService.getColor(option.id)}`, addMarginRight: true }), option.text, Object.values(option.state).some((val) => val != null && val.length !== 0) && _jsx(Dot, {})] }) }), option.node ? _jsx("div", { className: "p-3", children: option.node }) : null] }, index));
                                }) }), _jsx(AlertInfo, { message: "The items you select will be remembered for all staff", className: "mb-0 mt-4" })] }), _jsx("div", { className: "modal-footer", children: _jsx(OkButton, { onClick: () => setModalIsOpen(false) }) })] })] }));
};
export default FilterBox;
